module.exports = __webpack_public_path__ + "static/media/changephone.e1599486.gif";